import * as docx from 'docx';
import {saveAs} from 'file-saver';
import * as docxFunc from './Docxhelper';
import { getDocxElementsFromString } from '../WysiwygEditor/WysiwygHelpers';

export function generatePostControlNoteDocx(props
) {
    const Props = props.control;
    const generationTime = new Date(Date.now()).toLocaleString();
    const emptyText = 'Brak.';
    const noAttachmentsText = 'Brak załączników.';

      const tableBasicInfo = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Numer kontroli:', Props.number || emptyText),
            docxFunc.detailRow('Numer projektu:', Props.project.metadata.businessId || emptyText),
            docxFunc.detailRow('Tytuł projektu:', Props.project.title || emptyText),
        ],
    });

    const tableBeneficiaryInfo = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Identyfikator beneficjenta:', Props.project.beneficiaryIdentityNumber || emptyText),
            docxFunc.detailRow('Nazwa beneficjenta:', Props.project.beneficiaryName || emptyText),
            docxFunc.detailRow('Adres beneficjenta:', Props.project.beneficiaryAddress || emptyText),
        ],
    });

    const tableSubjectOfControlInfoTop = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Tryb kontroli:', Props.controlMode || emptyText),
            docxFunc.detailRow('Typ kontroli:', Props.controlType || emptyText),
            docxFunc.detailRow('Rodzaj kontroli:', Props.controlKind || emptyText),
            docxFunc.detailRow('Zespół kontrolujący:', Props.controlTeam || emptyText),
            docxFunc.detailRow('Zastosowana lista sprawdzająca:', Props.questionList.name || emptyText),
            docxFunc.detailRow('Planowany termin kontroli:', Props.plannedTerm || emptyText),
            docxFunc.detailRow('Data rozpoczęcia kontroli:', Props.term || emptyText),
            docxFunc.detailRow('Podmiot kontrolujący:', Props.controllingEntity || 'Brak podmiotu kontrolującego'),
            docxFunc.detailRow('Podmioty kontrolowane:', Props.allControlledParties || 'Brak podmiotów kontrolowanych'),
            docxFunc.detailRow('Miejsca przeprowadzenia kontroli:', Props.controlPlaces.length > 0 ? Props.controlPlaces.map(p => p.name).join("; ") : 'Brak miejsc przeprowadzenia kontroli'),
            docxFunc.detailRow('Inne kontrolowane projekty:', Props.otherControlledProjectNumbers?.length > 0 ? Props.otherControlledProjectNumbers.join("; ") : 'Brak innych kontrolowanych projektów.'),
            docxFunc.detailRow('Kontrolowane zamówienia:', Props.orders.length === 0 ? 'Brak kontrolowanych zamówień' : ''),
        ],
    });

    const tableSubjectOfControlInfoBottom = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Numery kontrolowanych WoP:', Props.paymentClaims.length > 0 ? Props.paymentClaims.map(p => p.number).join(", ") : 'Brak kontrolowanych wniosków'),
        ],
    });

    function attachments(attachments, attachmentsInDocument) {

        let attachmentsList = [];
        let attachmentsInDocumentArray = []
        
        if (!attachmentsInDocument.length || (attachments !== null && attachments.length === 0)) {
            attachmentsList.push(docxFunc.text(noAttachmentsText));
        }

        attachmentsInDocument.map(attachment => {
            attachments.map(att => {
                if(attachment.documentId === att.id){
                    attachmentsInDocumentArray.push(att);
                }
            })
        })
        const uniqueAttachments = attachmentsInDocumentArray.filter((obj, index) => {
            return index === attachmentsInDocumentArray.findIndex(o => obj.id === o.id);
        });

        uniqueAttachments.forEach((at, i) => {
            attachmentsList.push(docxFunc.text(`${++i}. ${at?.file?.fileName}`, undefined, true, undefined, i > 1));
        });

        return (
            new docx.Paragraph({
                children: attachmentsList,
            })
        )
    }

    const doc = new docx.Document({
        sections: [{
            properties: {
            },
            headers: {
                default: new docx.Header({
                    children: [
                        docxFunc.pageHeader(`${Props.number}-NOT`),
                        docxFunc.pageHeader('Utworzono ' + generationTime),
                    ],
                }),
            },
            children: [
                docxFunc.textWarning('WERSJA ROBOCZA'),
                docxFunc.brakeLine(20, true),
                docxFunc.header('NOTATKA POKONTROLNA'),
                docxFunc.header(`${Props.number}-NOT`),
                docxFunc.brakeLine(20),
                docxFunc.brakeLine(20),
                docxFunc.subTitleWithLines('Informacje o projekcie'),
                tableBasicInfo,
                docxFunc.brakeLine(1),
                docxFunc.subTitleWithLines('Dane beneficjenta ', -1),
                tableBeneficiaryInfo,
                docxFunc.brakeLine(1),
                docxFunc.subTitleWithLines('Informacje o kontroli'),
                tableSubjectOfControlInfoTop,
                ...docxFunc.ordersTable([["Numer ogłoszenia o zamówieniu", "Nazwa zamówienia", "Kontrakty"], ...Props.orders?.map((order) => [order.orderNumber, order.orderName, docxFunc.formatContractsValue(order.contracts)])]),
                tableSubjectOfControlInfoBottom,
                docxFunc.subTitle13('Treść notatki', 70, 120),
                ...getDocxElementsFromString(props.noteContent),
                docxFunc.subTitle13('Załączniki', 500, 160),
                attachments(Props?.documents, props.noteData.attachments),
            ],
            footers: {
                default: new docx.Footer({
                    children: [
                        new docx.Paragraph({
                            alignment: docx.AlignmentType.CENTER,
                            children: [
                                new docx.TextRun({
                                    children: [
                                        "Strona: ",
                                        docx.PageNumber.CURRENT,
                                        " z ",
                                        docx.PageNumber.TOTAL_PAGES
                                    ],
                                    size: 16,
                                    font: 'Calibri',
                                    color: '#616161'
                                }),

                            ],
                        }),
                    ],
                }),
            },
        }],
    });

    docx.Packer.toBlob(doc).then((blob) => {
        const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        const docblob = blob.slice(0, blob.size, mimeType);
        saveAs(docblob, `${Props.number}_NOT.docx`)
    });
}
